export function applyFreeDays(nbDays, freeDays) {
  const _freeDays = freeDays.split("|");
  let value = nbDays;

  for (const freeDay of _freeDays) {
    if (nbDays >= freeDay) {
      value = value - 1;
    }
  }

  return value;
}

export function computeTotal(state) {
  let price = state.products.reduce((accumulator, cartProduct) => {
    let warranty = 0;
    const productPrice = getCartProductPriceWithDiscount(state.numberOfDays, cartProduct);

    // Price of warranty
    if (state.warranty) {
      warranty = (1 + state.tvaRate) * state.warrantyDutyFree * state.numberOfDays;
    }

    return accumulator + (productPrice + warranty);
  }, 0);

  // Add promo code
  if (state.sellOff && state.sellOff.active) {
    price = price * (1 - state.sellOff.percent / 100)
  }

  return Number(price);
}

export function computeTotalWithoutDiscount(state) {
  const price = state.products.reduce((accumulator, cartProduct) => {
    let warranty = 0;
    const productPrice = getCartProductPrice(state.numberOfDays, cartProduct);

    // Price of warranty
    if (state.warranty) {
      warranty = (1 + state.tvaRate) * state.warrantyDutyFree * state.numberOfDays;
    }

    return accumulator + (productPrice + warranty);
  }, 0);

  return Number(price);
}

export function getClassColor(key) {
  const _classes = {
    "red-range": "red",
    "blue-range": "blue",
    "diamant-range": "grey",
    "black-range": "black",
    "rando-range": "purple",
    "infinity-range": "yellow darken-1",
  }

  return key in _classes ? _classes[key] : "";
}

export function getCartProductPrice(nbDay, cartProduct) {
  const tva = cartProduct.product.tvaRate;
  let cartProductPrice = getPriceFromPrices(nbDay, cartProduct.product.prices, tva);

  // Add equipement prices
  let key = -1;
  const equipmentsPrice = cartProduct.equipments.reduce((accumulator, equipment) => {
    key++;
    const equipmentPrice = getPriceFromPrices(nbDay, cartProduct.product.productEquipments[`${key}`].prices, tva);
    return equipment ? accumulator + equipmentPrice : accumulator;
  }, 0);

  return Number(cartProductPrice + equipmentsPrice);
}

export function getCartProductPriceWithDiscount(nbDay, cartProduct) {
  let cartProductPrice = getCartProductPrice(nbDay, cartProduct);

  // Add discount
  if (cartProduct.product.discounts.length) {
    for(const d of cartProduct.product.discounts) {
      if(d.active) {
        const percent = getPercentFromDiscount(nbDay, d);
        cartProductPrice = cartProductPrice * (1 - percent / 100);
      }
    }
  }

  return Number(cartProductPrice);
}

export function getPercentFromDiscount(nbDay, discount) {
  const properties = [
    "",
    "percentDayOne",
    "percentDayTwo",
    "percentDayThree",
    "percentDayFour",
    "percentDayFive",
    "percentDaySix",
    "percentDaySeven",
    "percentDayEight",
    "percentDayNine",
    "percentDayTen",
    "percentDayEleven",
    "percentDayTwelve",
    "percentDayThirteen",
    "percentDayFourteen"
  ];

  return discount[properties[nbDay]];
}

export function getProductPrice(nbDay, product) {
  const tva = product.tvaRate;
  let productPrice = getPriceFromPrices(nbDay, product.prices, tva);

  // Add discounts
  if (product.discounts.length) {
    for(const d of product.discounts) {
      if(d.active) {
        const percent = getPercentFromDiscount(nbDay, product.discount);
        productPrice = productPrice * (1 - percent / 100);
      }
    }
  }

  return Number(productPrice);
}

export function getPriceFromPrices(nbDay, prices, tva) {
  let price = 0;

  switch (nbDay) {
    case 1:
      price = prices.priceDutyFreeDayOne;
      break;
    case 2:
      price = prices.priceDutyFreeDayTwo;
      break;
    case 3:
      price = prices.priceDutyFreeDayThree;
      break;
    case 4:
      price = prices.priceDutyFreeDayFour;
      break;
    case 5:
      price = prices.priceDutyFreeDayFive;
      break;
    case 6:
      price = prices.priceDutyFreeDaySix;
      break;
    case 7:
      price = prices.priceDutyFreeDaySeven;
      break;
    case 8:
      price = prices.priceDutyFreeDayEight;
      break;
    case 9:
      price = prices.priceDutyFreeDayNine;
      break;
    case 10:
      price = prices.priceDutyFreeDayTen;
      break;
    case 11:
      price = prices.priceDutyFreeDayEleven;
      break;
    case 12:
      price = prices.priceDutyFreeDayTwelve;
      break;
    case 13:
      price = prices.priceDutyFreeDayThirteen;
      break;
    case 14:
      price = prices.priceDutyFreeDayFourteen;
      break;
  }

  return tva === undefined ? Number(price) : Number(price * (1 + tva));
}

export function hydratePriceObject(obj, data) {
  obj.priceDutyFreeDayOne = data[0];
  obj.priceDutyFreeDayTwo = data[1];
  obj.priceDutyFreeDayThree = data[2];
  obj.priceDutyFreeDayFour = data[3];
  obj.priceDutyFreeDayFive = data[4];
  obj.priceDutyFreeDaySix = data[5];
  obj.priceDutyFreeDaySeven = data[6];
  obj.priceDutyFreeDayEight = data[7];
  obj.priceDutyFreeDayNine = data[8];
  obj.priceDutyFreeDayTen = data[9];
  obj.priceDutyFreeDayEleven = data[10];
  obj.priceDutyFreeDayTwelve = data[11];
  obj.priceDutyFreeDayThirteen = data[12];
  obj.priceDutyFreeDayFourteen = data[13];
}

export function saveStatePlugin(store) {
  store.subscribe(
    (mutation, state) => {
      localStorage.setItem("cart", JSON.stringify(state.cart));
      localStorage.setItem("selectedLocale", state.selectedLocale);
    }
  )
}

export function updateTotals(state) {
  state.totalTtc = computeTotal(state);
  state.totalWithoutDiscountTtc = computeTotalWithoutDiscount(state);
  // Avoid division by 0
  state.discountPercent = state.totalWithoutDiscountTtc === 0 ? 0 : (state.totalWithoutDiscountTtc - state.totalTtc) / state.totalWithoutDiscountTtc * 100;
}

export function uuid() {
  return Math.random().toString(16).slice(2)
}

String.prototype.format = function () {
  let a = this;
  for (let k in arguments) {
    a = a.replace("{" + k + "}", arguments[k]);
  }
  return a;
}
